module.exports = __webpack_public_path__ + "img/technics__1_@2x.6f4a47f0.png";